import { useMemo } from 'react';
import { getPasswordScore } from 'anchor-password-policy';
export function usePasswordStrength(password, userInputs) {
    return useMemo(()=>{
        if (!password) return null;
        return getPasswordScore(password, userInputs);
    }, [
        password,
        userInputs
    ]);
}
